import * as React from 'react'
import { SVGProps, memo } from 'react'

const LogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={82}
    height={80}
    viewBox='0 0 82 80'
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M11.987 43.68c-3.722-1.981-6.614-4.485-8.674-7.511C1.301 33.168.201 29.905.01 26.379c-.116-3.549.733-7.05 2.547-10.506 2.35-4.478 5.585-7.987 9.702-10.528 4.117-2.542 8.636-3.904 13.556-4.088 4.97-.158 9.75.985 14.342 3.428 1.644.875 3.04 1.867 4.19 2.977 1.223 1.086 2.211 2.266 2.966 3.54a12.978 12.978 0 0 1 1.674 3.879L61.542 0 73.87 6.56 48.53 37.158c-2.724 3.022-5.618 5.634-9.525 7.54-3.882 1.857-8.17 2.782-12.867 2.774-4.696-.008-9.413-1.273-14.15-3.794Zm14.854-7.974c-2.33.316-4.632-.13-6.904-1.339-1.692-.9-3.012-2.038-3.96-3.414-.947-1.376-1.438-2.914-1.473-4.614.013-1.674.492-3.412 1.437-5.212 1.15-2.19 2.706-3.977 4.67-5.361 1.963-1.384 4.084-2.185 6.364-2.404 2.328-.194 4.58.288 6.755 1.446 1.644.875 2.94 2 3.887 3.376.973 1.327 1.477 2.84 1.513 4.54.06 1.652-.395 3.402-1.366 5.252-1.022 1.946-2.503 3.649-4.443 5.107-1.915 1.41-4.075 2.283-6.48 2.623Z'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M70.013 36.32c3.722 1.981 6.614 4.485 8.674 7.511 2.011 3.001 3.112 6.264 3.303 9.79.116 3.548-.733 7.05-2.547 10.506-2.35 4.478-5.585 7.987-9.702 10.528-4.117 2.542-8.636 3.904-13.556 4.088-4.97.158-9.75-.985-14.343-3.428-1.643-.875-3.04-1.867-4.189-2.977-1.223-1.086-2.211-2.266-2.966-3.54a12.978 12.978 0 0 1-1.674-3.879L20.458 80 8.13 73.44l25.34-30.599c2.724-3.022 5.618-5.634 9.525-7.54 3.882-1.857 8.17-2.782 12.867-2.774 4.696.008 9.412 1.273 14.15 3.794Zm-14.854 7.974c2.33-.316 4.632.13 6.904 1.339 1.692.9 3.012 2.038 3.96 3.414.947 1.376 1.438 2.914 1.473 4.614-.013 1.674-.492 3.412-1.437 5.212-1.15 2.19-2.706 3.977-4.67 5.361-1.963 1.384-4.085 2.185-6.364 2.404-2.328.194-4.58-.288-6.755-1.446-1.644-.875-2.94-2-3.887-3.376-.973-1.327-1.477-2.84-1.513-4.54-.06-1.652.395-3.402 1.366-5.252 1.022-1.946 2.503-3.649 4.443-5.107 1.915-1.41 4.075-2.283 6.48-2.623Z'
      clipRule='evenodd'
    />
  </svg>
)

const Memo = memo(LogoIcon)
export default Memo
